import factory from "@/assets/lottie/isometric-factory.json.asset.json";
import cloud from "@/assets/lottie/isometric-cloud-computing.json.asset.json";
import packaging from "@/assets/lottie/isometric-automatic-product-packaging.json.asset.json";
import finance from "@/assets/lottie/isometric-artificial-intelligence-in-finance-management.json.asset.json";
import gears from "@/assets/lottie/two_gears.json.asset.json";
import production from "@/assets/lottie/isometric-automatic-production-of-products.json.asset.json";
import machineLearning from "@/assets/lottie/isometric-machine-learning-for-artificial-intelligence-1.json.asset.json";
import loading from "@/assets/lottie/isometric-automatic-loading-of-products.json.asset.json";
import blockDiagram from "@/assets/lottie/isometric-block-diagram.json.asset.json";
import robotDelivery from "@/assets/lottie/isometric-contactless-delivery-by-robot-1.json.asset.json";
import dashboard from "@/assets/lottie/isometric-data-dashboard-with-infographics-and-statistics.json.asset.json";

/** Lottie animations ported from the original Webflow site. */
export const LOTTIE = {
  factory: factory.url,
  cloud: cloud.url,
  packaging: packaging.url,
  finance: finance.url,
  gears: gears.url,
  production: production.url,
  machineLearning: machineLearning.url,
  loading: loading.url,
  blockDiagram: blockDiagram.url,
  robotDelivery: robotDelivery.url,
  dashboard: dashboard.url,
} as const;

export type LottieKey = keyof typeof LOTTIE;

/** Which animation heads each product module page. */
export const FEATURE_LOTTIE: Record<string, LottieKey> = {
  sales: "finance",
  production: "production",
  purchases: "packaging",
  stocks: "loading",
  planning: "dashboard",
  scheduling: "gears",
  cost: "finance",
  "technical-data": "blockDiagram",
};

/** Animation used on add-on detail pages (falls back to the static isometric art). */
export const ADDON_LOTTIE: Record<string, LottieKey> = {
  wms: "loading",
  pdm: "blockDiagram",
  services: "robotDelivery",
  "ai-agents": "machineLearning",
};
